
import _ from 'lodash'
import { defineComponent, computed, ref, nextTick } from 'vue'
import ChartReport from './components/chart-report.vue'

export default defineComponent({
  name: 'Air8ChartReport',
  components: { ChartReport },
  props: {
    options: Object,
    isEmpty: Boolean,
    loading: Boolean
  },
  setup (props) {
    const chartRef = ref()
    const chartLoading = computed(() => props.loading)
    // const showLegend = computed(() => !_.isEmpty(props.legendOptions))
    // const showRightLegend = computed(() => !_.isEmpty(props.legendRightOptions))
    const updateOption = computed(() => {
      return { replaceMerge: ['xAxis', 'yAxis', 'series'] }
    })

    async function resizeChartHeight () {
      await nextTick()
      _.invoke(chartRef.value, 'resize')
    }
    return {
      chartRef,
      chartLoading,
      updateOption,
      resizeChartHeight
    }
  }
})
